import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import voucherReducer from './voucherSlice';

export const store = configureStore({
  reducer: {
        voucher: voucherReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
